import { Table, Typography } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit } from "../../../../../../utils/helper/constants";
import { changeLoader } from "../../../../../../redux/reducers/loader";
import { useNavigate } from "react-router-dom";
import { capitalizeName, roundToDecimal } from "../../../../../../utils/helper/utils";

const SalesByDriver = ({ inputData, tabIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [paginationModel] = useState(paginationLimit);
  const [dataSource, setDataSource] = useState([]);

  const getAllDriverReport = async () => {
    dispatch(changeLoader(true));
    try {
        const params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
        };

        const response = await globalRequest(
        Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_DRIVER,
        "get",
        {},
        { params },
        true
        );

        const apiResponse = response?.data;

        if (apiResponse?.status === "SUCCESS") {
        const items = apiResponse?.data || [];

        const resultData = items.map((item, index) => ({
            key: item.driverId || index,
            driverId: item.driverId,
            driverName: item.driverName,
            totalOrders: item.totalOrder,
            totalAmount: roundToDecimal(item.totalAmount, 2),
        }));

        setDataSource(resultData);
        } else {
        toast.error(apiResponse?.message || "Failed to fetch data");
        }
    } catch (e) {
        toast.error(e?.message || "Something went wrong");
    } finally {
        dispatch(changeLoader(false));
    }
    };

  useEffect(() => {
    getAllDriverReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const columns = [
    {
        title: "Driver Name",
        dataIndex: "driverName",
        key: "driverName",
        render: (text) => capitalizeName(text || "-"),
    },
    {
        title: "Total Amount (SAR)",
        dataIndex: "totalAmount",
        key: "totalAmount",
        render: (text) => (text ? text.toFixed(2) : "-"),
    },
    {
        title: "Total Orders",
        dataIndex: "totalOrders",
        key: "totalOrders",
        render: (text, record) => (
        <Typography
            onClick={() =>
            navigate(`/get-driver-orders/${record?.driverId}`, {
                state: { inputData, tabIndex },
            })
            }
            className="cursor-pointer text-[#176B53]"
        >
            {text || "-"}
        </Typography>
        ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      className="multi-tables responsive"
      pagination={false}
    />
  );
};

export default SalesByDriver;
